
import Vue from 'vue';
// using name 'SwitchToggle' because switch already reserved by html
/**
 * Switch / Toggle component.
 */
export default Vue.extend({
  name: 'SwitchToggle',
  inheritAttrs: false,
  props: {
    /**
     * Switch value, bind in v-model.
     */
    value: {
      type: Boolean,
      default: false
    },
    /**
     * Make switch disabled.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      focus: false
    };
  },
  methods: {
    input(value: boolean) {
      this.$emit('input', value);
    },
    handleBlur() {
      this.focus = false;
    },
    handleFocus() {
      this.focus = this.disabled ? false : true;
    },
    handleToggle() {
      if (this.disabled) {
        return null;
      }
      return this.input(!this.value);
    }
  }
});
